import { Dashboard } from '@/features/dashboard';

export const EmployeeDashboard = Dashboard;
